module.exports = __webpack_public_path__ + "media/images/logo-205babbcb781d929cf45d8dcb3afa21e.svg";